import React from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { reactPlugin } from 'app-insights';

import { SignInWidget } from 'components/Widgets';

import styles from './SignInPage.module.scss';

const SignInPage = () => (
  <>
    <SignInWidget />
    <div className={styles.sign_in_footer}>
      <p>
        Trouble signing in? Call{' '}
        <a className={styles.phone_link} href="tel:(866) 367-3271">
          (866) 367-3271.
        </a>
      </p>
    </div>
  </>
);

export default withAITracking(reactPlugin, SignInPage, 'SignInPage');
